import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Subscribes to the NotificationChannel via ActionCable.
// Shows a toast when a new notification arrives and bumps every visible
// notification badge (mobile + desktop headers each render their own bell).
// This controller must be mounted ONCE per page — see layouts/*.html.erb.

export default class extends Controller {
  connect() {
    if (window._notificationChannelActive) {
      this._wasDuplicate = true
      return
    }
    window._notificationChannelActive = true

    this.subscription = consumer.subscriptions.create("NotificationChannel", {
      received: (data) => this.handleNotification(data)
    })
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
    if (!this._wasDuplicate) {
      window._notificationChannelActive = false
    }
  }

  handleNotification(data) {
    if (data.type === "notification") {
      this.incrementAllBadges()
      this.showToast(data.title, data.body)
    }
  }

  incrementAllBadges() {
    document.querySelectorAll(".notification-badge").forEach((badge) => {
      const current = parseInt(badge.textContent, 10) || 0
      const newCount = current + 1
      badge.textContent = newCount > 99 ? "99+" : newCount
      badge.style.display = ""
    })
  }

  showToast(title, body) {
    const event = new CustomEvent("toast:show", {
      detail: {
        type: "info",
        message: `${title}: ${body}`
      },
      bubbles: true
    })
    document.dispatchEvent(event)
  }
}
